import { connect, ConnectedProps } from 'react-redux';
import { BillingOption } from '../../../../../../../../shared/utils/billing-options';
import { RootState } from '../../../../../../../../store/root-reducer';
import PlansSection from './plans-section';

const mapStateToProps = (state: RootState) => ({
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetAccountSubscriptionRequestStatus:
    state.billingAndSubscription.getAccountSubscriptionRequest.status,
  sendGetAccountSubscriptionResponse:
    state.billingAndSubscription.getAccountSubscriptionResponse,
  sendGetPlansResponse: state.billingAndSubscription.getPlansResponse,
  sendPurchaseSubscriptionRequestStatus:
    state.billingAndSubscription.purchaseSubscriptionRequest.status,
  sendGetPurchaseModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseModifySubscriptionRequest.status,
  isDemoAccount: state.home.isDemoAccount,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  onSelectPlan: (
    planId: number,
    planName: string,
    counts?: { prospectsCount: number; emailsCount: number },
  ) => void;
  planCycle: BillingOption;
  selectedPlanId: number;
  onSchedule: VoidFunction;
  isScheduleRequestLoading: boolean;
  isPaddlePolling?: boolean;
};

export default connector(PlansSection);
